// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__36XnO","insightsList":"newBusinessInsightsMenu_insightsList__1dRSw","active":"newBusinessInsightsMenu_active__vDh93"};